import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'apnst-formly-field-number-filter',
  templateUrl: './formly-field-number-filter.component.html',
  styleUrls: ['./formly-field-number-filter.component.css']
})
export class FormlyFieldNumberFilterComponent extends FieldType{

  numberFormGroup = this.fb.group({
    operator: ["gt"],
    from: [null],
    to: [null]
  })
  constructor(private fb: UntypedFormBuilder) { 
    super();
  }

  ngOnInit(): void {
    // For Checking Form Change
    this.numberFormGroup.valueChanges.subscribe(data=>{
      this.formControl.setValue(data);
    });
  }

  get type() {
    return this.to.type || 'text';
  }

  get operator(){
    return this.numberFormGroup.get("operator");
  }
  get fromNumber(){
    return this.numberFormGroup.get("from");
  }
  get toNumber(){
    return this.numberFormGroup.get("to");
  }

}
